function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1920px",
    height: "800px",
    viewBox: "0 0 1920 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,71.764706%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 603.019531 0.320312 L 686.8125 149.996094 L 0 799.679688 L 0 0.320312 Z M 603.019531 0.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,57.647059%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 0 799.679688 L 603.019531 0.320312 L 686.8125 149.996094 Z M 0 799.679688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.294118%,77.254902%,77.254902%)",
      fillOpacity: 1
    },
    d: "M 0 799.679688 L 744.683594 581.40625 L 1661.898438 799.679688 Z M 0 799.679688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.941176%,40%,17.254902%)",
      fillOpacity: 1
    },
    d: "M 686.8125 149.996094 L 1194.652344 0.320312 L 603.019531 0.320312 Z M 686.8125 149.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(83.137255%,85.098039%,85.098039%)",
      fillOpacity: 1
    },
    d: "M 1300.800781 297.796875 L 1661.898438 799.679688 L 744.683594 581.40625 L 0 799.679688 L 686.8125 149.996094 Z M 1300.800781 297.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,89.019608%,89.019608%)",
      fillOpacity: 1
    },
    d: "M 686.8125 149.996094 L 1300.800781 297.796875 L 1920 0.320312 L 603.019531 0.320312 Z M 686.8125 149.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(38.823529%,64.705882%,43.137255%)",
      fillOpacity: 1
    },
    d: "M 1300.800781 297.796875 L 1381.4375 258.804688 L 1691.246094 799.679688 L 1661.898438 799.679688 Z M 1300.800781 297.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(50.196078%,80%,55.294118%)",
      fillOpacity: 1
    },
    d: "M 1920 0.320312 L 1300.800781 297.796875 L 1661.898438 799.679688 L 1920 799.679688 Z M 1920 0.320312 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.d82349c9d07a54987362fe3a0f95e327.svg";
export { ForwardRef as ReactComponent };